const upload = function(event) {
  const formData = new FormData();
  const images = event.target.files;
  for (let i = 0; i < images.length; i++) {
    formData.append("uploads", images[i]);
  }

  return formData;
};

export default upload;
